// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const SpeakerOn = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M67.69 78.106A32.4 32.4 0 0 0 87.5 48.218c-.004-13.418-8.441-25.616-20.994-30.354a2 2 0 0 0-1.412 3.742C76.099 25.76 83.496 36.456 83.5 48.218a28.408 28.408 0 0 1-17.369 26.204 2 2 0 0 0 1.559 3.684Zm-5.427-14.192a17.01 17.01 0 0 0 10.402-15.695c0-7.045-4.43-13.452-11.023-15.942a2 2 0 0 0-1.414 3.742c5.046 1.906 8.437 6.809 8.437 12.2 0 5.25-3.124 9.965-7.96 12.011a2 2 0 1 0 1.558 3.684ZM12.5 58.424h15.097c.355 0 .702.094 1.008.273l17.793 10.384V26.919L28.605 37.304a1.994 1.994 0 0 1-1.008.273H12.5v20.847Zm35.898 16.139c-.349 0-.696-.091-1.008-.272L27.056 62.424H10.5a2 2 0 0 1-2-2V35.577a2 2 0 0 1 2-2h16.556L47.39 21.709a2 2 0 0 1 3.008 1.727v49.127a1.999 1.999 0 0 1-2 2Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default SpeakerOn;
